import React from 'react'
import HeroSection from '../../components/HeroSection'
import  FAQSection  from '../../components/FAQSection'
import Contact from '../../pages/public/Contact'
import  CourseSection  from '../../components/CourseSection'
import  PricingSection  from '../../components/PricingSection'
import Testimonials from './Testimonials'
const Home = () => {
    return (
        <>
            <HeroSection />
            <CourseSection />
            <PricingSection />
            <Testimonials/>
            <FAQSection />
            <Contact />
        </>
    )
}

export default Home
